import React from 'react'
import './StepHeader.scss'
import { formatStepImageUrl } from 'util/beaker2-step-image-url'

export const StepHeader = ({ title, copy, imageId, alt }) => {
  const imageUrl = formatStepImageUrl(imageId)
  return (
    <div>
      <div className="step-intro step-subcopy">
        {title && (
          <h2
            className="step-header"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <div className="step-copy" dangerouslySetInnerHTML={{ __html: copy }} />
      </div>
      {imageUrl && (
        <div className="step-image">
          <img src={imageUrl} alt={alt} style={{ width: '100%' }} />
        </div>
      )}
    </div>
  )
}

export default StepHeader
